import React from 'react';
import PropTypes from 'prop-types';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { makeStyles } from '@material-ui/core';
import Button from 'components/buttons/Button';
import DialogTitle from './DialogTitle';
import Dialog from './Dialog';
import { accentThree1000 } from '../../themes/colors';

const useStyles = makeStyles({
  IconRoot: {
    color: accentThree1000,
  },
});

const ErrorNotificationDialog = (props) => {
  const {
    toggle, isOpen, errorMessage, title,
  } = props;
  const classes = useStyles(props);
  return (
    <Dialog
      open={isOpen}
      onBackdropClick={toggle}
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>
        <ErrorOutlineIcon classes={{ root: classes.IconRoot }} /> {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {errorMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primaryCTA" onClick={toggle} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ErrorNotificationDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  errorMessage: PropTypes.element.isRequired,
  title: PropTypes.string,
};

ErrorNotificationDialog.defaultProps = {
  title: 'Error',
};

export default ErrorNotificationDialog;
